import { type ElementType } from "react";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { LoadingButton } from "@mui/lab";

export const PageRoot = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        maxWidth: 560,
        mx: "auto",
        px: { xs: 3, md: 0 },
        py: { md: 8, xs: 4 },
    }),
);

export const PageTitle = styled(Typography)<{ component?: ElementType }>(({ theme }) =>
    theme.unstable_sx({
        fontWeight: 700,
        mb: 3,
    }),
);

export const PageSubtitle = styled(Typography)(({ theme }) =>
    theme.unstable_sx({
        mb: 4,
    }),
);

export const ImageWrapper = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: 2,
        mb: 4,
    }),
);

export const Image = styled("img")(({ theme }) =>
    (theme as any).unstable_sx({
        width: "100%",
        height: 200,
        objectFit: "cover",
        display: { md: "none", xs: "block" },
    }),
);

export const ContentBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        p: 3,
        bgcolor: "white",
    }),
);

export const ContentTitle = styled(Typography)<{ component?: ElementType }>(({ theme }) =>
    theme.unstable_sx({
        fontWeight: 700,
        mb: 2,
    }),
);

export const ContentText = styled(Typography)(({ theme }) =>
    theme.unstable_sx({
        mb: 4,
    }),
);

export const ReloginButton = styled(LoadingButton)(({ theme }) =>
    theme.unstable_sx({
        py: "12px",
    }),
);
